angular.module('unica_invitation_transfer.invitation_transfer_controllers')

.controller('InvitationTransferListController', function(
	CONFIG,
	$rootScope, $scope, $state, $stateParams,
	$confirm,
	InvitationTransferListService, InvitationTransferDeleteService
) {
	$scope.invitationTransfers = [];
	$scope.limit  = 10;
	$scope.offset = 0;
	$scope.canLoad = true;
	$scope.event_id = $stateParams.event_id;

	$rootScope.getEvent( $stateParams.event_id );


	$scope.loadInvitationTransfers = function() {
		$scope.showLoader();
		$scope.canLoad = false;

		InvitationTransferListService
			.list( $stateParams.event_id, $scope.limit, $scope.offset )
			.then(function(data) {
				$scope.hideLoader();

				if ( !data.error ) {
					data = $rootScope.parseInvitationTransfers( data );

					$scope.invitationTransfers = $scope.invitationTransfers.concat( data );
					if ( data.length == 0 ) {
						$scope.canLoad = false;
					} else {
						$scope.canLoad = true;
						$scope.offset = $scope.offset + data.length;
					}
				} else {
					$rootScope.manageError(data);
				}
			});
	};

	$scope.loadInvitationTransfers();

	$scope.deleteInvitationTransfer = function(invitationTransferId) {

		$confirm({
			title: 'Sei sicuro di voler eliminare il Transfer Assegnato?',
			text: 'Confermi la cancellazione del Transfer Assegnato?'
		}).then(function() {

			$scope.showLoader();
			InvitationTransferDeleteService
				.delete( invitationTransferId  )
				.then(function(data) {
					$scope.hideLoader();

					if (!data.error) {
						angular.forEach($scope.invitationTransfers, function(invitationTransfer, key) {
							if ( invitationTransfer.id == invitationTransferId ) {
								$scope.invitationTransfers.splice(key, 1);
							}
						});
						$scope.showSuccessMsg('Transfer Assegnato eliminato con successo!', '');
					} else {
						$rootScope.manageError(data);
					}

				});

		}, function() {
			// Cancel
		});

	};

})

;